module.exports = __webpack_public_path__ + "img/extra-poin.d2356a79.png";